export default __webpack_public_path__ + "static/media/marauders-map-v3-03-02.e1cdd220.jpg";